import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { MissJonesIndexCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/index-cards-3x5/miss-jones-index-card-stack-content/miss-jones-index-card-stack-content.component';
import { IndexCardStack } from './index-card-stack';
import { MissJonesCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/index-cards-3x5/miss-jones-card-stack-background/miss-jones-card-stack-background.component';
import { Orientation } from '../../../../enum/dto/orientation.enum';

export class MissJonesIndexCardStack extends IndexCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return MissJonesCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return MissJonesIndexCardStackContentComponent;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Landscape;
  }
}
